import store from "@/store";
import OfflineQueueService from "@/services/OfflineQueueService";

export const ResponseInterceptor = (response) => {
  store.commit("app/setConnected", true);
  OfflineQueueService.flush();
  return response;
};

export default ResponseInterceptor;
